// @flow

import { type Card } from './types';

export function getHolderName(card: Card): string {
  return card.holderName;
}
